import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import CheckoutTemplate from '../../../components/template/CheckoutTemplate/CheckoutTemplate'
import jwt from 'jsonwebtoken'
import NewModal from '../../../components/molecules/NewModal/NewModal'
import { Button } from '../../../components'
import { api } from '../../../utils'
import { CARRELLO, PAGINEDETAIL } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import LoadingSvg from '../../../components/atoms/Loading/Loading'
import { isGuestAllowed } from '../../../utils/servicegift'

export const createToken = (carrello_main_id) => {
  return jwt.sign(carrello_main_id, process.env.JWT_SECRET_KEY)
}

const CheckoutPage = ({ carrello_main_id }) => {
  const { utente, fetching, fetched } = useSelector((state) => state.utente)
  const { service_gift } = useSelector((state) => state.servicegift)
  const [carrello_main, setCarrelloMain] = useState(undefined)
  const [error, setError] = useState(false)
  const router = useRouter()
  const t = useTrans()

  useEffect(async () => {
    // ! Nel caso si volesse rimandare l'utente verso homepage prima nel componentDidMount
    // ! service_gift && !service_gift?.premium && router.push('/')
    await api
      .get(CARRELLO + carrello_main_id + '/checkout/', { params: { lang: router.locale } })
      .then((res) => {
        setCarrelloMain(res.data)
      })
      .catch((err) => {
        console.log(err)
        setError(true)
      })
  }, [])

  useEffect(() => {
    if (fetched && !utente) {
      // se sipec => login
      // se sg => login solo se non è abilitato il checkout come ospite
      if (
        !service_gift ||
        (service_gift?.premium && (!router.query.guest || !isGuestAllowed(service_gift)))
      ) {
        router.push(`/myaccount/accedi?next=${router.asPath.replace('?guest=true', '')}`)
      }
    }
  }, [fetched, utente, service_gift?.nome])

  if (!carrello_main_id) {
    return (
      <NewModal
        visible={true}
        alert={true}
        title={t('La tua Sessione Checkout è scaduta')}
        actions={[
          <Button
            variant="primary"
            label={t('Torna indietro')}
            onClick={() => router.push('/cart')}
          />,
        ]}
      />
    )
  }

  if (fetching) {
    return <LoadingSvg />
  }

  if (fetched && !utente) {
    if (
      !service_gift ||
      (service_gift?.premium && (!router.query.guest || !isGuestAllowed(service_gift)))
    ) {
      return <LoadingSvg />
    }
  }

  return service_gift?.premium || !service_gift ? (
    carrello_main ? (
      <CheckoutTemplate
        service_gift={service_gift}
        carrello_main={carrello_main ? carrello_main : null}
      />
    ) : error ? (
      <NewModal
        visible={true}
        alert={true}
        title={t('Impossibile procedere al checkout')}
        actions={[
          <Button
            variant="primary"
            label={t('Torna al carrello')}
            onClick={() => router.push('/cart')}
          />,
        ]}
      />
    ) : (
      <LoadingSvg />
    )
  ) : (
    <>404</>
  )
}

export default CheckoutPage

export async function getServerSideProps({ locale, query }) {
  const { token } = query
  try {
    const carrello_main_id = jwt.verify(token, process.env.JWT_SECRET_KEY)

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'checkout',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    return {
      props: {
        page,
        carrello_main_id: carrello_main_id,
      },
    }
  } catch (error) {
    console.log(error)
    return { props: { carrello_main_id: null } }
  }
}
